import { Card, CardContent } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReceiptIcon from '@mui/icons-material/Receipt';
import HorizontalSplitIcon from '@mui/icons-material/HorizontalSplit';
import './Dashboard.css';
import SessionService from '../../services/SessionService';
import { getUserDetails } from '../../Helper/userActivityApi';
import invoiceIcon from './../../assets/invoice.png';
import documentScanIcon from './../../assets/search.png';

const Dashboard = () => {
    const navigate = useNavigate();
    const userGroups = SessionService.getCognitoGroups();

    const formsNavigate = () => {
        navigate('/search');
    };

    const shipmentNavigate = () => {
        navigate('/invoice-module');
    };

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userId = localStorage.getItem('user_id');
                if (!userId) {
                    console.warn('No user_id found in localStorage');
                    return;
                }
                
                const response = await getUserDetails(userId);
                console.log('User data response:', response);
                
                // Check if response has the expected structure
                if (response?.data?.body && Array.isArray(response.data.body) && response.data.body.length > 0) {
                    localStorage.setItem('userDetails', JSON.stringify(response.data.body[0]));
                } else if (response?.data) {
                    // Fallback if structure is different
                    localStorage.setItem('userDetails', JSON.stringify(response.data));
                } else {
                    console.warn('Unexpected response structure:', response);
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
        fetchUserData();
    }, [])

    return (
        <div className='container'>
            <div className='row'>
                <div className='col-12 service-header-font'>
                    My Services
                </div>
                {userGroups.includes('documents_module') && (
                    <div className='col-sm-6 col-md-4 col-lg-3'>
                        <Card onClick={formsNavigate} className='pointer'>
                            <CardContent className='row'>
                                <div className='col-4 place-center'>
                                    <img src={documentScanIcon} style={{ width: '100%' }} alt="Document Scan Icon" />
                                </div>
                                <div className='col-8 p-0'>
                                    <span className='p-0 fl-l'>
                                        Document Scanning
                                    </span>
                                    <br></br>
                                    <span className='p-0 fl-l fs-12'>
                                        Scan, digitize, and organize documents effortlessly.
                                    </span>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                )}
                {userGroups.includes('invoice_module') && (
                    <div className='col-sm-6 col-md-4 col-lg-3'>
                        <Card onClick={shipmentNavigate} className='pointer'>
                            <CardContent className='row'>
                                <div className='col-4 place-center'>
                                    <img src={invoiceIcon} style={{ width: '100%' }} alt="Invoice Icon" />
                                </div>
                                <div className='col-8 p-0'>
                                    <span className='p-0 fl-l'>
                                        Invoice Financing
                                    </span>
                                    <br></br>
                                    <span className='p-0 fl-l fs-12'>
                                        Efficiently generate, track, and manage invoices
                                    </span>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Dashboard;
